import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const Marker = (props) => {
  return (
/*    <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="15"
      viewBox="0 0 88 88"
      width="15"
      style={ { paddingTop:"2px", paddingLeft:"2px" } }>
      
      <polygon points="46.79 69.204 21.796 44.21 20.063 45.649 45.352 70.937 46.79 69.204"/>
      <path d="M57.707,30.707l-13,13a1.8286,1.8286,0,0,0,2.586,2.586l13-13a1.8286,1.8286,0,0,0-2.586-2.586Z"/>
      <path d="M83.707,23.293l-16-16a1,1,0,0,0-1.3457-.0625L63.2371,9.823l17.94,17.94L83.77,24.6387A1,1,0,0,0,83.707,23.293Z"/>
      <path d="M23.3417,42.9276,48.0724,67.6583l31.8221-38.35L61.6914,11.1055ZM61.707,34.707l-13,13a3.8283,3.8283,0,0,1-5.414-5.414l13-13a3.8283,3.8283,0,0,1,5.414,5.414Z"/>
      <path d="M23.293,75.707a.9994.9994,0,0,0,1.414,0l2.7315-2.7314,16.1722-.9512L18.9756,47.39l-.9517,16.1719L15.293,66.293a.9994.9994,0,0,0,0,1.414Z"/>
      <path d="M61,79H19.42l2.17-2.17-7.42-7.42L4.29,79.29a1.0023,1.0023,0,0,0-.21,1.09A.9873.9873,0,0,0,5,81H61a1,1,0,0,0,0-2Z"/>
      <path d="M69,79H65a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z"/>
     </svg>
*/
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="8.000000pt" height="8.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M0 3290 l0 -1100 545 0 c300 0 545 -2 545 -5 0 -3 -162 -329 -360
-725 -198 -396 -360 -722 -360 -725 0 -3 245 -5 545 -5 l545 0 365 730 365
730 0 1100 0 1100 -1095 0 -1095 0 0 -1100z"/>
<path d="M2930 3290 l0 -1100 545 0 545 0 -365 -730 -365 -730 550 0 550 0
365 730 365 730 0 1100 0 1100 -1095 0 -1095 0 0 -1100z"/>
</g>
</svg>
  );
};

export default Marker;
